export default __webpack_public_path__ + "be954e9281a33f868f5a462b0bbcc34d.png";